import { SUCCESS, REQUEST, FAILED } from 'crom-api-constants'

export const ENTITY_SEARCH_START = 'ENTITY_SEARCH_START'
export const ENTITY_SEARCH_END = 'ENTITY_SEARCH_END'
export const SOCKET_ENTITY_SEARCH_START = `SOCKET_${ENTITY_SEARCH_START}`

export const MERGE_STORED_COLLECTION = 'MERGE_STORED_COLLECTION'

export const ENTITY_SEARCH_REQUEST = `ENTITY_SEARCH_${REQUEST}`
export const ENTITY_SEARCH_REQUEST_SUCCESS = `ENTITY_SEARCH_${REQUEST}_${SUCCESS}`
export const ENTITY_SEARCH_REQUEST_FAILED = `ENTITY_SEARCH_${REQUEST}_${FAILED}`

export const ENTITY_STACK_SEARCH_SET_ENTITIES = 'ENTITY_STACK_SEARCH_SET_ENTITIES'

export const COLLECTION_INDEX = 'searchResult'

export const LOCALE_PREFIX = 'scenes.Gnosus.components.EntityStack.components.StackContent.components.SearchContent'
export const ENTER_KEY_CODE = 13
